import React from 'react';

const PageNotFound = () => {
    return (
        <div>
            <h2>Page not found......</h2>
        </div>
    );
};

export default PageNotFound;